export { default } from './HistoryLog.jsx';
